import { clsx } from '../../../ds/clsx';
import type { ControllingFigures } from './api';
import styles from './figures.module.css';

/** Right column of Controlling 04: the „Beurkundet" tile with its delta and „Je Person" (labels from the API). */

function deltaTone(delta: string): string | undefined {
  if (delta.startsWith('+')) return styles.deltaUp;
  if (delta.startsWith('−') || delta.startsWith('-')) return styles.deltaDown;
  return undefined;
}

export function NotarizedTile({ notarized }: { notarized: ControllingFigures['notarized'] }) {
  return (
    <section className={clsx(styles.card, styles.sideCard)} aria-label="Beurkundet">
      <div className={styles.sideEyebrow}>Beurkundet</div>
      <div className={styles.statValue}>{notarized.label}</div>
      <div className={clsx(styles.statDelta, deltaTone(notarized.delta))}>{notarized.delta}</div>
    </section>
  );
}

export function PerPerson({ rows }: { rows: ControllingFigures['perPerson'] }) {
  return (
    <section className={clsx(styles.card, styles.sideCard)} aria-label="Je Person">
      <div className={styles.sideEyebrow}>Je Person</div>
      <div className={styles.people}>
        {rows.length === 0 ? (
          <div className={styles.peopleEmpty}>Keine Beurkundung in diesem Zeitraum.</div>
        ) : null}
        {rows.map((row) => (
          <div key={row.userId} className={styles.person}>
            <span className={styles.personName}>{row.name}</span>
            <span className={styles.personValue}>{row.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
